import { getSilencedCases } from "../modules/silence-cases/get-silenced-cases.js";
import { isAnyCaseSilenced } from "../modules/silence-cases/is-any-case-silenced.js";

export const getters = {
  dashboardURL: (state) => {
    let dashboardURL = import.meta.env.VITE_DASHBOARD_URL;
    if (state.ssoSubdomain)
      return dashboardURL.replace(/ondeck|demo|live/, state.ssoSubdomain);
    return dashboardURL;
  },
  groupChannel: (state) => {
    let group = "";

    if (state.group) {
      if (state.hospitalId) {
        group = `gc_hospitalId-${state.hospitalId}::group-${state.group.replace(
          / /g,
          "_"
        )}`;
      }

      if (state.emsAgencyId) {
        group = `gc_emsAgencyId-${
          state.emsAgencyId
        }::group-${state.group.replace(/ /g, "_")}`;
      }
    }

    return group;
  },
  showUnsilenceMenu: (state) =>
    isAnyCaseSilenced({ caseTracker: state.caseTracker }),
  silencedCases: (state) =>
    getSilencedCases({ caseTracker: state.caseTracker }),
};
